import { useIsSignedIn } from "PFApp/hooks";
import { WithLayout } from "PFApp/routes/route_helpers";
import { useAuthStoreActions } from "PFApp/stores/auth_store";
import NotFoundComponent from "PFComponents/not_found/not_found";
import { sidebar } from "PFCore/base/page_layouts";
import { Navigate } from "react-router";

import { useDeeplink } from "../use_deeplink";

const NotFoundRoute = () => {
  const { saveDeeplink } = useDeeplink();

  const { isSignedIn } = useIsSignedIn();

  const { clearTokens } = useAuthStoreActions();

  if (isSignedIn) {
    return (
      <WithLayout layout={{ sidebar: sidebar }}>
        <NotFoundComponent
          message="The page was not found."
          buttonMessage="Click here to go to the homepage"
          buttonUrl="/"
        />
      </WithLayout>
    );
  } else {
    saveDeeplink();
    clearTokens();
    return <Navigate to="/users/signin" replace />;
  }
};

export default NotFoundRoute;
